import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import React from 'react'
import Link from 'components/Link'
import { copyToClipboardDomUtil } from 'client/utils/dom/copy-to-clipboard/index.js'
import openSuccessBannerAction from 'modules/banner/actions/open-success/index.js'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import useIntl from 'modules/component/utils/hooks/useIntl'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  linkCopiedToClipboard: {
    id: 'ArticleContent.linkCopiedToClipboard',
    defaultMessage: 'Link successfully copied to clipboard.'
  }
})

/**
 * @param props
 * @param props.url
 * @param props.chunkAnchorMarkdownObj
 * @constructor
 */
export default function ArticleChunkAnchor (props) {
  const {
    url,
    chunkAnchorMarkdownObj
  } = props
  const {
    chunkAnchorMarkdown,
    chunkAnchorId
  } = chunkAnchorMarkdownObj

  const dispatch = useDispatch()
  const intl = useIntl()

  const handleClickAnchor = (event) => {
    event.preventDefault()
    copyToClipboardDomUtil(event.currentTarget.href)
    dispatch(
      openSuccessBannerAction(
        formatMessageIntlUtil(intl, messages.linkCopiedToClipboard)
      )
    )
  }

  if (!chunkAnchorMarkdown) {
    return <></>
  }

  return (
    <div
      style={{
        color: 'initial',
        display: 'flex',
        alignItems: 'center',
        margin: `${STYLES_MARGIN.BIG} 0 0 0`
      }}
    >
      <Link
        to={`${url}#${chunkAnchorId}`}
        onClick={handleClickAnchor}
        style={{
          color: 'initial',
          textDecoration: 'none'
        }}
      >
        <div
          dangerouslySetInnerHTML={{ __html: chunkAnchorMarkdown }}
        />
      </Link>
    </div>
  )
}
